import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../client';

export interface ConsumerAppointment {
  id: number;
  therapistId: number;
  therapistFirstName: string;
  therapistLastName: string;
  therapistProfilePhotoS3Key?: string;
  slotDate: string;
  slotTime: string;
  sessionType: 'INTAKE' | 'REGULAR' | 'CRISIS';
  status: 'PENDING_PAYMENT' | 'CONFIRMED' | 'CANCELLED' | 'COMPLETED';
  amountCents: number;
  notes?: string;
  cancelledAt?: string;
  cancellationReason?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ConsumerAppointmentsResponse {
  bookings: ConsumerAppointment[];
  total: number;
}

export function useConsumerAppointments() {
  return useQuery({
    queryKey: ['consumer-appointments'],
    queryFn: async (): Promise<ConsumerAppointmentsResponse> => {
      const response = await apiClient.get('/bookings/consumer/my-bookings');
      return response.data;
    },
  });
}

export function useCancelAppointment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      bookingId,
      reason,
    }: {
      bookingId: number;
      reason?: string;
    }) => {
      const response = await apiClient.post(`/bookings/${bookingId}/cancel`, {
        reason: reason || 'Cancelled by user',
      });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['consumer-appointments'] });
      queryClient.invalidateQueries({ queryKey: ['consumer-bookings'] });
      queryClient.invalidateQueries({ queryKey: ['consumer-sessions'] });
    },
  });
}
